module.exports = __webpack_public_path__ + "static/media/toast_icon_info.00221e31.svg";